import { styled } from '../../utils/styled'
import { UploadIcon } from '../icons/UploadIcon'

import Card from '../Card'

interface StyledFileUploadProps {
  disabled: boolean
  $isPreviewMode: boolean
  $isError: boolean
  $fileUploadContainerColorsByState?: {
    default: string
    onDragOver: string
  }
}
export const StyledFileUploadContainer = styled(Card)<StyledFileUploadProps>(
  ({
    disabled,
    theme,
    $isPreviewMode: isPreviewMode,
    $isError: isError,
    $fileUploadContainerColorsByState: fileUploadContainerColorsByState
  }) => {
    let backgroundColor: string = theme.tokens.background.main.default

    if (
      (isPreviewMode && fileUploadContainerColorsByState == null) ||
      (disabled && fileUploadContainerColorsByState == null)
    ) {
      backgroundColor = theme.tokens.background.tonal.soft.default
    } else if (!isPreviewMode && fileUploadContainerColorsByState != null) {
      backgroundColor = fileUploadContainerColorsByState.default
    } else if (isPreviewMode && fileUploadContainerColorsByState != null) {
      backgroundColor = fileUploadContainerColorsByState.onDragOver
    }

    return {
      backgroundColor,
      opacity: isPreviewMode ? 0.5 : 1,
      color: disabled ? theme.tokens.foreground.main.disabled : theme.tokens.foreground.main.primary,
      minHeight: '72px',
      border: isError ? `1px solid ${theme.tokens.border.error.primary}` : `1px solid ${theme.tokens.border.main.tonal}`
    }
  }
)

export const StyledFileInformation = styled('ul')(({ theme }) => ({
  margin: 0,
  padding: `0 ${theme.spacing(2)} 0 ${theme.spacing(2)}`
}))

export const StyledMessage = styled('div')(({ theme }) => ({
  color: theme.tokens.foreground.main.primary,
  display: 'flex',
  alignItems: 'center',
  paddingLeft: '6px',
  span: {
    paddingLeft: '6px'
  }
}))

interface StyledUploadIconProps {
  $isPreviewMode: boolean
  $uploadIconColorsByState?: {
    default: string
    onDragOver: string
  }
}

export const StyledUploadIcon = styled(UploadIcon)<StyledUploadIconProps>(
  ({ theme, $isPreviewMode: isPreviewMode, $uploadIconColorsByState: uploadIconColorsByState }) => {
    const color =
      uploadIconColorsByState != null && isPreviewMode
        ? uploadIconColorsByState.onDragOver
        : uploadIconColorsByState?.default
    return {
      ...(uploadIconColorsByState != null && { color })
    }
  }
)
